import { employees } from "./employees";
import { financial } from "./financial";
import { clients } from "./clients";

export const businessIntelligence = {
	header: {
		financial: "Financial",
		employees: "Employees",
		clients: "Customers",
		period: "Period",
	},
	chartCards: {
		filters: {
			consumption: "Consumption",
			ppu: "PPU",
		},
	},
	employees,
	financial,
	clients,
};
